// extracted by mini-css-extract-plugin
export default {"main":"NavbarTemplate_main__mWFF+"};